import React from "react";
import { Icon } from "../../../_components";

export function MapsManager() {
  return (
    <div className="chronos-help-topic-page chronos-maps-manager-topic">
      <p>
        Open the Maps Manager by clicking the unfolded map icon in the right
        toolbar <Icon icon="far fa-map" />. Once your maps are created, you can{" "}
        <strong>select</strong>, <strong>edit</strong> and{" "}
        <strong>delete</strong> them from the Maps Manager. You can also browse
        all the maps in your Chronicle, and search their titles.
      </p>
      <p>
        If you create <strong>New Maps</strong> from here, the system will take
        you back to this window on completion for a faster mass-map upload
        workflow.
      </p>
      <p>
        The green <strong>Select</strong> button closes the Maps Manager and
        shows the selected map in the main Chronicles interface.
      </p>
      <p>
        The <strong>Delete</strong> button deletes your map <em>AND</em> all Map
        Markers on that Map. This is an irreversible action, so only do it if
        you're sure!
      </p>
      <p>
        The <strong>Edit</strong> button opens the Edit Map interface.
      </p>
      <h4 className="chronos-topic-subheader">Edit Map: General</h4>
      <p>You'll recognize this interface from when you created your map!</p>
      <p>
        The Maps's <strong>Title</strong> is shown inside the Maps Manager, to
        help you distinguish between maps. Choose something descriptive you'll
        recognize later!
      </p>
      <p>
        The Map's <strong>Description</strong> is not shown anywhere, and simply
        for your reference.
      </p>
      <p>
        To replace your map with a new image, simply drag and drop the file into
        the <strong>Map Image</strong> field. The suggested size for maps is 4k
        x 3.5k pixels. The suggested format is webp or jpg.
      </p>
      <p>
        The <strong>Attribution</strong> fields allow you to give credit to
        other people if the original map work is theirs. (Remember, you{" "}
        <strong>must</strong> have permission to use other people's work
        publicly!) The Attribution appears on the bottom right of the map
        section. If you've added an Attribution URL, it will open in a new tab
        when clicked.
      </p>
      <h4 className="chronos-topic-subheader">Edit Map: Settings</h4>
      <p>
        <strong>Zoom Settings</strong> affect how much you or viewers can zoom
        the map. There are 3 sliders here: Min, Initial Zoom and Max. Min
        controls how far the map can be zoomed out (making the map smaller), and
        Max controls how far the map can be zoomed in, as well as how far the
        Map will zoom in when panning to a Map Marker (e.g. when you or a viewer
        clicks an Event that is linked to a Map Marker). Initial Zoom sets the
        starting zoom level whenever the map is shown or changed. Adjust these
        values by sliding the relevant slider to a new position on the bar.
      </p>
      <p>
        The <strong>X Coordinate</strong> (East/West or Left/Right) and{" "}
        <strong>Y Coordinate</strong> (North/South or Up/Down) define the
        default position of your map when it loads. Unless you edit them when
        creating the map, these coordinates will automatically set to the center
        of your map. These are measured in pixels.
      </p>
      <p>
        <strong>Show Zoom Controls</strong>: Your viewers can zoom in and out of
        your map using a scroll wheel, and also using the + and - buttons in the
        top right of the screen. These show by default, but you can disable them
        by clicking the switch to the "No" positon. Note, this does not disable
        zooming, only whether the buttons are shown. To disable zooming
        completely, slide the Zoom sliders so they are set to the same level.
      </p>
      <p>
        <strong>Custom CSS Class</strong> allows you to use your own CSS styling
        rules (if you have access to that feature). Please note that if you plan
        to write additional CSS rules to target Maps or Timelines, do not change
        positions or sizing! This can lead to errors in calculating coordinates
        on the Map and Timelines!
      </p>
    </div>
  );
}
